import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const AddPlanModal = ({ open, onClose, onSubmit, title, children, isEdit = false }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ minWidth: '120px', mr: 2 }} color="primary" variant="outlined">
                    Cancel
                </Button>
                <Button onClick={onSubmit} sx={{ minWidth: '120px' }} color="primary" variant="contained">
                    {isEdit ? 'Update' : 'Add'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddPlanModal;
